import { useLanguage } from '@treneo/shared/i18n';

import { FormControl, MenuItem, Select, type SelectChangeEvent } from './components';

export const LanguageBar = () => {
  const { currentLanguage, supportedLanguages, changeLanguage } = useLanguage();

  const onLanguageChange = (event: SelectChangeEvent<string>) => {
    void changeLanguage(event.target.value);
  };

  const menuItems = supportedLanguages.map(language => (
    <MenuItem key={language.code} value={language.code}>
      {language.name}
    </MenuItem>
  ));

  return (
    <FormControl size='small'>
      <Select value={currentLanguage.code} onChange={onLanguageChange}>
        {menuItems}
      </Select>
    </FormControl>
  );
};
